import axios from "axios";
import $ from "jquery";

const state = {
  destinationStatistics: {},
  destinationPost: {},
  publishedDestinationPosts: [],
  unpublishedDestinationPosts: [],
};

const getters = {
  destinationStatistics(state) {
    return state.destinationStatistics;
  },

  destinationPost(state) {
    return state.destinationPost;
  },

  publishedDestinationPosts(state) {
    return state.publishedDestinationPosts;
  },

  unpublishedDestinationPosts(state) {
    return state.unpublishedDestinationPosts;
  },
};

const mutations = {
  setDestinationStatistics(state, statistics) {
    state.destinationStatistics = statistics;
  },

  setDestinationPost(state, post) {
    state.destinationPost = post;
  },

  setPublishedDestinationPosts(state, posts) {
    state.publishedDestinationPosts = posts;
  },

  setUnpublishedDestinationPosts(state, posts) {
    state.unpublishedDestinationPosts = posts;
  },

  deletePublishedDestinationPost(state, id) {
    let index = state.publishedDestinationPosts.findIndex((p) => p.id == id);
    state.publishedDestinationPosts.splice(index, 1);
  },

  deleteUnpublishedDestinationPost(state, id) {
    let index = state.unpublishedDestinationPosts.findIndex((p) => p.id == id);
    state.unpublishedDestinationPosts.splice(index, 1);
  },
};

const actions = {
  async fetchDestinationStatistics({ commit, rootState }) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    await axios
      .get(`${apiUrl}/destination-post/statistics`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        commit("setDestinationStatistics", res.data);
      });
  },

  async fetchDestinationPost({ commit, rootState }, id) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    await axios
      .get(`${apiUrl}/destination-post/${id}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        commit("setDestinationPost", res.data);
      });
  },

  async fetchPublishedDestinationPosts({ commit, rootState }) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    await axios
      .get(`${apiUrl}/destination-post/published`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        commit("setPublishedDestinationPosts", res.data);
      });
  },

  async fetchUnpublishedDestinationPosts({ commit, rootState }) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    await axios
      .get(`${apiUrl}/destination-post/unpublished`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        commit("setUnpublishedDestinationPosts", res.data);
      });
  },

  async publishDestinationPost({ commit, dispatch, rootState }, data) {
    dispatch("showSpinnerLoading", null, { root: true });

    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    await axios
      .put(
        `${apiUrl}/destination-post/publish/update?id=${data.id}&publish=${data.publish}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
      .then(() => {
        dispatch("hideSpinnerLoading", null, { root: true });

        if (data.publish) {
          $.alert("post published successfull");
          commit("deleteUnpublishedDestinationPost", data.id);
        } else {
          $.alert("post unpublished successfull");
          commit("deletePublishedDestinationPost", data.id);
        }
      });
  },

  async createDestinationPost({ rootState }, post) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    return await axios.post(`${apiUrl}/destination-post/create`, post, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  },

  async updateDestinationPost({ rootState }, data) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    return await axios.put(`${apiUrl}/destination-post/update/${data.id}`, data.post, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  },

  async deleteDestinationPost({ dispatch, rootState }, id) {
    dispatch("showSpinnerLoading", null, { root: true });

    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    await axios
      .delete(`${apiUrl}/destination-post/delete?id=${id}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then(() => {
        $.alert("post deleted successfull");

        dispatch("hideSpinnerLoading", null, { root: true });
      });
  },

  async uploadDestinationPostPhoto({ rootState }, formData) {
    const accessToken = rootState.authStore.token;
    const apiUrl = process.env.VUE_APP_API_URL;

    return await axios.post(`${apiUrl}/destination-post/photo/upload`, formData, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
      },
    });
  },

  async deleteDestinationPostPhoto({ rootState }, data) {
    const accessToken = rootState.authStore.token;
    const apiUrl = process.env.VUE_APP_API_URL;

    await axios
      .delete(`${apiUrl}/destination-post/photo/delete`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        data: data,
      })
      .then(() => {
        $.alert("Image deleted !");
      });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
